<template>
    <div class="animated fadeIn apinvfrm">        
        <b-card>
            <div slot="header">
                AP Invoice VOID Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="8">
                    <b-form-row>
                        <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>AP Void Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING" disabled></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>AP Void Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date"  :disabled="!(saveEnabled)"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-form-row >                      
                    <b-input-group >
                        <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.vendorinfo" disabled></b-form-input>
                    </b-input-group>
                    <b-form-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>PO/SO Number</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.po" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.invoice" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-form-row>                      
                    <b-form-row>
                        <b-col lg="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.invdate" type="date" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="7">
                            
                            <b-input-group >
                                 <b-input-group-prepend style="width: 50px;"><label>T.O.P</label></b-input-group-prepend>
                                <b-form-input v-model="model.top" type="number" style="max-width: 70px !important;" disabled></b-form-input>
                                <b-input-group-append>
                                     <b-input-group-text>
                                        Hari
                                    </b-input-group-text>
                                </b-input-group-append>
                                <b-input-group-prepend class="ml-2"><label>Invoice Due Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.duedate" type="date" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-form-row>     
                    <b-form-row>
                        <b-col cols="6" >
                            <b-input-group >
                                <b-input-group-prepend><label >Invoice Amount</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" disabled></b-form-select>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice DP/Termin</label></b-input-group-prepend>
                                <b-form-select v-model="model.tagihandp" :plain="true" :options="YesNo" disabled></b-form-select>
                                <b-input-group-append v-if="(model.tagihandp==1)"> <span class="input-group-text">Termin #</span></b-input-group-append>
                                <b-form-select v-if="(model.tagihandp==1)" v-model="model.termin" :plain="true" :options="invoiceTerms" disabled></b-form-select>
                                <b-input-group-append v-if="(model.tagihandp==0)" class="ml-1">
                                    <b-btn text="Button" @click="showApDownpay" variant="warning">
                                        Settlement to DP/Termin Invoices 
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row v-if="(model.matauang !== uanguser)">
                        <b-col cols="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Exchange Rate {{model.matauang}}</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number :disabled="(model.matauang === uanguser)" class="form-control text-right" separator="," v-model="model.ratekurs" disabled></my-number>
                            </b-input-group>
                        </b-col>
                    </b-form-row>                      

                </b-col>
                <b-col lg="4">
                        <b-input-group >
                            <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')" disabled></b-form-input>
                        </b-input-group>

                            <b-input-group>
                                <b-input-group-prepend><label>Internal Budget</label></b-input-group-prepend>
                                <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                            </b-input-group>

                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
            </b-row>
            <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblApLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="apLines.items"
                    :fields="apLines.fields"
                    :current-page="apLines.page"
                    :per-page="apLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(unitprice)="data">
                        {{data.item.unitprice|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(nilaippn)="data">
                        {{data.item.nilaippn|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(nilaidue)="data">
                        {{data.item.nilaidue|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editApLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                      <b-tabs card v-model="tabIndex">
                        <b-tab title="INVOICE ITEM DETAIL" active>
                            <b-row h-align="center">
                                <b-col lg="6" xl="6" class="pl-0">
                                    <b-input-group v-if="(model.ibudghdkey)">
                                        <b-input-group-prepend><label>Intern.Budget Line</label></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.budgetline" readonly></b-form-input>
                                        <b-form-checkbox v-model="apLinesObj.ibudgdtkeyflag" value="YES" unchecked-value="NO"  class="ml-2 pt-2" disabled>NOT RELATED</b-form-checkbox>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.uraian_dt" disabled></b-form-input>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-input-group-prepend><label>GL Account#</label></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.kodeacc" disabled></b-form-input>
                                        <b-form-input readonly v-model="apLinesObj.namaacc"  style="width:50% !important;"></b-form-input>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col lg="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.quantity" type="number" :precision="2" v-b-tooltip.hover :title="apLinesObj.quantity" readonly></b-form-input>
                                                <b-form-input v-model="apLinesObj.unitsize" v-b-tooltip.hover :title="apLinesObj.unitsize" class="ml-1" placeholder="Unit Size" disabled></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Unit Price</span></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number :minus="true" class="form-control text-right" v-model="apLinesObj.unitprice" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="6" class="pl-0">
                                    <b-form-row>
                                        <b-col xl="10">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Net Amount</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number :minus="true" class="form-control text-right" v-model="apLinesObj.nilai" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="2">                            
                                            <b-form-checkbox id="chkPPN" class="ml-1 mt-2 text-left" v-model="apLinesObj.kenappn" value=1 unchecked-value=0 disabled>PPN(VAT)</b-form-checkbox>
                                        </b-col>
                                    </b-form-row >                      

                                    <b-form-row v-if="(apLinesObj.kenappn==1)">
                                        <b-col xl="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Tarif DPP</label></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.dppnlain" disabled></b-form-input>
                                                <b-input-group-append><span class="input-group-text">% </span></b-input-group-append>
                                                <b-input-group-append><span class="pt-2"><strong> &nbsp; * Net Amount</strong> </span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="4">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Tarif PPN</span></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.ppn" disabled  type="number" v-b-tooltip.hover :title="apLinesObj.ppn"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >         
                                    <b-form-row>
                                        <b-col xl="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                                <b-form-select v-model="apLinesObj.pasalpph" :plain="true" :options="lookupPPH" disabled></b-form-select>
                                            </b-input-group>                                          
                                        </b-col>
                                        <b-col xl="4">
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Tarif PPH</span></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.pph" disabled  type="number" v-b-tooltip.hover :title="apLinesObj.pph"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >                          
                                    <b-row no-gutters>
                                        <b-col xl="10">
                                            <b-input-group>
                                                <b-form-select style="font-size:0.78rem !important; margin-left:21px;"  v-model="calcPPh" :plain="true" :options="calcuationPPH" disabled></b-form-select>
                                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                                <my-number style="width:40% !important;"  class="form-control text-right" v-model="apLinesObj.nilaipph" :precision="2" disabled></my-number>
                                            </b-input-group>                                          
                                        </b-col>
                                    </b-row>

                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="INVOICE ITEM DIMENSION">
                            <b-row align-h="between">
                                <b-col lg="6" v-if="prepaidexp">
                                    <h5  class="ml-2">Setting Amortization - Prepaid Expenses</h5>
                                    <b-input-group >
                                        <b-input-group-prepend><label >Duration/Period</label></b-input-group-prepend>
                                        <b-form-input  v-model="apLinesObj.amortzbln" type="number" disabled></b-form-input>
                                        <b-input-group-append>
                                        <span class="input-group-text">month(s)</span>
                                        </b-input-group-append>
                                    <!-- </b-input-group>
                                    <b-input-group > -->
                                        <b-input-group-prepend><span class="ml-1 pt-2">Starting &nbsp;</span></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.amortzdate" type="date" style="width:30% !important;" disabled></b-form-input>                                        
                                    </b-input-group>

                                    <b-input-group >
                                        <b-input-group-prepend><label>Debit Account</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="apLinesObj.amortzaccount" ></b-form-input>
                                    </b-input-group>

                                </b-col>
                                <b-col lg="6">
                                    <v-dim :model="apLinesObj" :key="updateDimDtl"></v-dim>
                                </b-col>
                            </b-row>
                        </b-tab>
                      </b-tabs>
                        <b-row class="justify-content-center mt-1">
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="5">
                        <b-row>
                            <div class="ml-3">
                                Showing {{((apLines.page - 1) * apLines.limit + 1)}}
                                to <span v-if="((apLines.page * apLines.limit)>apLines.total)">{{apLines.total}}</span>
                                    <span v-else>{{apLines.page * apLines.limit}}</span>
                                <strong> of {{apLines.total}} entries </strong>
                            </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="apLines.limit"  style="width:80px;"/>
                            </b-input-group>
                    </b-col>
                    <b-col cols="5">
                        <b-pagination
                            align="right"
                            :total-rows="apLines.total"
                            :per-page="apLines.limit"
                            v-model="apLines.page"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-card>    

            <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                        <b-input-group>
                            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                            <b-form-input  v-model="model.uraian" disabled></b-form-input>
                        </b-input-group>
                        <b-form-row>
                            <b-col lg="4">
                                <b-input-group >
                                    <b-input-group-prepend><label>No. Faktur Pajak</label></b-input-group-prepend>
                                    <b-form-input v-model="model.nofaktur" disabled></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col lg="4">
                                <b-input-group >
                                    <b-input-group-prepend class="d-md-inline d-lg-none"><label>Tgl. Faktur</label></b-input-group-prepend>
                                    <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>Tgl. Faktur &nbsp;</span></b-input-group-prepend>
                                    <b-form-input v-model="model.tglfaktur" type="date" disabled></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col lg="4">
                                <b-input-group >
                                    <b-input-group-prepend><label style="text-align: right !important;">Kurs Pajak {{model.matauang}}</label></b-input-group-prepend>
                                    <my-number :disabled="(model.matauang === uanguser)" class="form-control text-right" separator="," v-model="model.kursppn" disabled></my-number>
                                </b-input-group>
                            </b-col>
                        </b-form-row>                      
                        <b-form-row>
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                        <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" v-model="model.totalpph" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-col>
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend class="d-md-inline d-lg-none"><label>&nbsp;</label></b-input-group-prepend>
                                    <b-form-checkbox id="chkGrossUp" class="ml-2 mt-2" v-model="model.grossup" value=1 unchecked-value=0 @change="calcAmountDue" disabled>
                                        Gross Up W/H Tax(PPh)
                                    </b-form-checkbox>
                                </b-input-group>
                            </b-col>
                        </b-form-row>     
                    </b-col>
                    <b-col lg="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">subtotal</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px; font-size:small;"  v-model="calcVAT" :plain="true" :options="calcuationVAT" disabled></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="model.nilaippn" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                            </b-input-group>
                        </div>
                    </b-col>
               </b-row>
            <b-row align-h="center" no-gutters>
                <b-col md="6" lg="5"  xl="3">
                    <b-input-group >
                        <b-input-group-prepend><label>AP Posting Group</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.postgrpname" disabled></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col md="6" lg="4" xl="3">
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>&nbsp;</label></b-input-group-prepend>
                        <b-form-checkbox  class="ml-3 mt-2" v-model="model.chargeable" value=1 unchecked-value=0 disabled>
                        Chargeable to Customer
                        </b-form-checkbox>
                    </b-input-group>
                </b-col>
            </b-row>               
            <b-row class="justify-content-center mb-2">
                <div style="width:300px;">
                    <b-input-group >
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>
        </b-card>

        <b-modal v-model="dpConfirm" size="lg" title="List of Invoice DP/Termin" 
            :centered="true"  header-bg-variant="primary" :hide-footer="true" :no-close-on-esc="true" :no-close-on-backdrop="true" :hide-header-close="true">
            <div class="report-wraper">
                    <table style="width: 100%;" class="">
                        <thead>
                            <tr>
                            <th width="30px"></th>
                            <th style="text-align:center" width="100px">Settled Amount</th>
                            <th style="text-align:center" width="100px">AP Number</th>
                            <th style="text-align:center" width="100px">Invoice No.</th>
                            <th style="text-align:center" width="100px">PO Number</th>
                            <th>Description</th>
                            <th style="text-align:center" width="30px">Rp,$,¥</th>
                            <th style="text-align:center" width="120px">Invoice Total (Excl.VAT)</th>
                            <th style="text-align:center" width="100px">UnSettled Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in apDownpay" :key="row.notgl" >
                                <td width="30px">    
                                    <b-form-checkbox v-model="row.selected" :value="1" :unchecked-value="0" disabled/>
                                </td>
                                <td class="disabled" style="text-align:right">{{row.nilai | numFormat('0,0.00')}}</td>
                                <td class="disabled">{{row.nomor}}</td>
                                <td class="disabled">{{row.invoice}}</td>
                                <td class="disabled">{{row.po}}</td>
                                <td class="disabled">{{row.uraian}}</td>
                                <td class="disabled" width="30px">{{row.matauang}}</td>
                                <td class="disabled" style="text-align:right">{{row.totalinvxppn | numFormat('0,0.00')}}</td>
                                <td class="disabled" style="text-align:right">{{row.SisaDP | numFormat('0,0.00')}}</td>
                            </tr>
                        </tbody>
                    </table>
            </div>                  
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="danger" class="ml-1" @click="dpConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>
<style lang="scss">
    .apinvfrm {
        .input-group {
            padding-bottom:2px;
            .input-group-prepend {
                label {
                    padding-top: 5px;
                    padding-right: 5px;
                    width: 130px;
                }
            }
        }
        .form-group {
            margin-bottom:2px;
            .input-group {
                padding-bottom:0;
            }
        }
        .row-details-form {
            label {
            text-align: right !important;
            }
            legend {
            text-align: right !important;;
            }
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dimReadonly";
import apinv from "../../apis/apinv";
import procure from "../../apis/procure";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, minValue, maxLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading,myNumber, vDim},
  mixins: [validationMixin],
  validations: {
        model: {
            apvoid: { required },
            apvoidkey: { required },
            tanggal: { required },
        },
        apLinesObj: {
            kodeacc: { required },
            uraian_dt: { required },
            quantity: { required, minValue:minValue(0.00000001) },
            unitprice: { required, minValue:minValue(0.00000001) },
            nilai: { required, minValue:minValue(0.00000001) },
            // ppn: { numeric },
            // kenappn: { required },
            pasalpph: {required : (function() {
                if ((this.apLinesObj.nilaipph || 0) == 0) {
                    return true;
                } else if (((this.apLinesObj.pasalpph || '')=='') || (this.apLinesObj.pasalpph== 'N/A') || (this.apLinesObj.pasalpph== 'NO WHT')){
                    return false;
                } else return true;
            })},
            ibudgdtkey: { required:(function() {
                if (this.model.ibudghdkey) {
                    if (this.apLinesObj.ibudgdtkey) {
                        if (this.apLinesObj.ibudghdkey=='N/A')
                            return true;
                        else {
                            if (this.model.ibudghdkey==this.apLinesObj.ibudghdkey) {
                                return true;
                            } else {
                                toastr.error(`Budget Line not from Internal Budget`,'Line/Detail AP',10000);                                
                                return false;
                            }
                        }
                    } else return false;
                } else return true;
            }) },

        },
  }, 
  data() {
    return {
        inputBerlanjut: 1,
        inputLineBerlanjut: 1,
        saveEnabled:true,
        isLoading:false,
        lkuBudgetShow: false,
        lkuBudgetInternShow: false,
        lkuBudgetInternData:{},
        lkuCashflowData:{},
        lkuCashflowShow: false,
        lkuCashflowCaller:'model',        
        lkuApGroupShow: false,
        lkuVendorShow: false,
        lkuPorderShow: false,
        updateDimHdr:false,
        updateDimDtl:true,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        coa:[],
        uanguser: this.$store.state.user.matauang,
        postGroups:[],
        currency:[{value:'IDR',text:'IDR'}],
        invoiceTerms: [{ value: '', text: '-' }, { value: 'Term#1', text: 'Term#1' }, { value: 'Term#2', text: 'Term#2' },
                { value: 'Term#3', text: 'Term#3' }, { value: 'Term#4', text: 'Term#4' }
        ],
        calcVAT:1,
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Otomatis)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[],
        YesNo :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
        model: {
            vendor: '',
            po: '',
            uraian: '',
            tanggal: moment().format('YYYY-MM-DD'),
            postgroup: '',
            kodecash: '',
            matauang: 'IDR',
            tagihandp: 0,
            termin: '',
            nofaktur: '',
            tglfaktur: '',
            totalinv: 0, nilaippn:0,grossup:0, totalpph:0,
            ratekurs: 1, kursppn:1, DimTableKey:'',
            top:0,//term of payment,
            duedate:'',invdate:'', ibudghdkey:''
        },
        apLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "uraian_dt",
                    label: "Description",
                },
                {
                    key: "glAccount",
                    label: "GL Account"
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:90px",
                },
                {
                    key: "unitprice",
                    label: "Unit price",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilai",
                    label: "Amount NETT",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaippn",
                    label: "Amount VAT",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaidue",
                    label: "Amount DUE",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        apLinesObj: {
            kodeacc: '',
            uraian_dt: '',
            quantity: 0,
            unitprice: 0,
            nilai: 0, nilaipph:0,
            ppn: 0,
            kenappn: 0,
            pasalpph: 'NO WHT',
            pph: 0, unitzise:'', DimTableKey:'', amortzbln:0, amortzdate:'',
            amortzkodeacc:'',amortznamaacc:'',amortzaccount:'',
            ibudgdtkey:'',ibudgdtkeyflag:'YES'
        },
        tabIndex:0,
        lkuCoaShow:false,
        lkuCoaColler:'',
        saveClick:false,
        apDpSttl: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nilai",
                    label: "Settled Amount",
                    thStyle: "width:140px",
                    thClass: "text-center",
                    tdClass: "text-right"
                },
                {
                    key: "nomor",
                    label: "AP Number",
                    thStyle: "width:140px",
                },
                {
                    key: "invoice",
                    label: "Invoice No.",
                    thStyle: "width:140px",
                },
                {
                    key: "po",
                    label: "PO Number",
                    thStyle: "width:140px",
                },
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥",
                    sortable: true
                },
                {
                    key: "totalinvxppn",
                    label: "Total Invoice\ (Excl. VAT)",
                    thStyle: "width:140px",
                    thClass: "text-center",
                    tdClass: "text-right"
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        dpConfirm: false,
        apDownpay:[],
        prepaidexps:[],
        prepaidexp:false
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidApLines() {
      this.$v.apLinesObj.$touch();
      return this.$v.apLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function(){
      if (this.$route.params.apinvkey)  {
          toastr.info('Loading AP Detail, please wait')
          try {
            const [a,b,c,f,data] = await Promise.all([apinv.postgroup(), apinv.pasalpph(),apinv.currency(),apinv.prepaidexp(),apinv.detail(this.$route.params)]) ;
            this.postGroups = a;
            this.lookupPPH = b;
            this.currency = c;
            this.prepaidexps=f;
            // const data = await apinv.detail(this.$route.params);  
            const row = data[0][0];
            console.log (row.duedate);
            this.saveEnabled=(row.posting === 0);
            row.top = (row.duedate) ? moment(row.duedate).diff(moment(row.invdate),'days'): 0;
            row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
            row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : '';
            row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : '';   

            for (var key in row) {
                this.model[key] = row[key];
            }
            this.calcVAT=row.calcVAT||1;
            this.apLines.items = data[1];
            this.apLines.total=this.apLines.items.length;
            this.apDpSttl.items = data[2];
            this.apDpSttl.total=this.apDpSttl.items.length;
            row.apvoid = row.apvoid || 0; 
            if (row.apvoid==1)  {
                this.saveEnabled=(row.posting === 0);
                this.model.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            } else {
                this.saveEnabled=true;
                this.model.nomor=`${row.nomor}/VOID`;           
                this.model.apvoid=1; 
                this.model.apvoidkey= row.apinvkey;
                this.model.apinvkey= '';
                this.model.tanggal = moment().format('YYYY-MM-DD');
            }

            if (row.apvoid==0)  {
                this.model.totalinv= -1*this.model.totalinv;
                this.model.nilaidpp= -1*this.model.nilaidpp;
                this.model.nilaippn= -1*this.model.nilaippn;
                this.model.totalpph= -1*this.model.totalpph;
                this.apLines.items.forEach(function (trx) {
                    trx.apdtlkey = '';
                    trx.apinvkey='';
                    trx.nilai = -1*trx.nilai;
                    trx.dpp =  -1*trx.dpp ;
                    trx.nilaippn =  -1*trx.nilaippn ;
                    trx.nilaidue =  -1*trx.nilaidue ;
                    trx.nilaipph =  -1*trx.nilaipph ;
                    trx.dpdeduc =  -1*trx.dpdeduc ;
                });
                this.apDpSttl.items.forEach( function (trx) {
                    trx.idrowunik=''
                    trx.apinvkey='';
                    trx.nilai=-1*trx.nilai;
                });
            }


            this.tahun=0;
            this.updateDimHdr = !this.updateDimHdr;
            setTimeout(() => {
                this.calcTotalDtlAp();
            }, 1000); 
            // this.$forceUpdate();
            this.inputBerlanjut=0;
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 

  },
  methods: {
    async showApDownpay() {
        try {
            this.apDownpay =[];
            let ApDpIdx;
            if (this.apDownpay.length==0) {
                console.log('(apDownpay.length==0)');
                this.apDpSttl.items.forEach((d,idx)=>{
                    const dp1={};
                    for (var key in d) {
                        dp1[key] = d[key];
                    }
                    dp1.selected=1;
                    dp1.apinvkey=d.notgl;
                    dp1.notgl=d.apinvkey;
                    dp1.nilai=d.nilaisettl;
                    this.apDownpay.push(dp1);    
                });
            } 
            // console.log('this.apDownpay : ',this.apDownpay);
            this.dpConfirm=true;
        } catch (error) {
            console.log(error);
            // this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    calcPrice : function() {
        this.apLinesObj.nilai = parseFloat(this.apLinesObj.quantity) * parseFloat((this.apLinesObj.unitprice || 0));
        this.calcTaxes();
    },
    calcTaxes : function() {
        this.apLinesObj.dppnlain=this.apLinesObj.dppnlain || 100; 
        this.apLinesObj.nilainett = this.apLinesObj.nilai;
        this.apLinesObj.dpp = parseFloat(this.apLinesObj.nilainett) * parseFloat(this.apLinesObj.dppnlain) / 100;
        this.apLinesObj.ppn = this.apLinesObj.ppn || 10;
        if (this.apLinesObj.kenappn == 1) {
            this.model.grossup = 0;
            this.apLinesObj.nilaippn = (this.apLinesObj.ppn/100) * this.apLinesObj.dpp;
        } else {
            this.apLinesObj.nilaippn = 0;
        }
        
        
        if (this.model.grossup == 1)
            this.apLinesObj.dpp = this.apLinesObj.dpp * (100 / (100 - this.apLinesObj.pph));

        this.apLinesObj.nilaidue = this.apLinesObj.nilainett + this.apLinesObj.nilaippn;
        if (this.calcPPh == 1) {
            this.apLinesObj.nilaipph = this.apLinesObj.dpp * parseFloat(this.apLinesObj.pph) / 100
        }
        this.$forceUpdate();
    },
    calcAmountDue : function() {
        this.model.ttlamtdue = parseFloat(this.model.ttlnetto || 0) + parseFloat(this.model.nilaippn || 0);
        this.model.totalap= (this.model.grossup==0) ? this.model.ttlamtdue : this.model.ttlamtdue-this.model.totalpph;
        console.log('Total AP : ',this.model.totalap);
        toastr.info(`Total AP after W/H Tax : ${this.model.totalap.toLocaleString(undefined, { maximumFractionDigits: 2 })}`);

    },    

    closeApLines: function(){
        const opened= this.apLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },

    editApLines : function (obj,callback) {
        this.closeApLines();
        this.apLines.selected = obj;
        this.apLinesObj.apdtlkey = '';
        this.apLinesObj.kodeacc = '';
        this.apLinesObj.uraian_dt = '';
        this.apLinesObj.quantity = 0;
        this.apLinesObj.unitprice = 0;
        this.apLinesObj.nilai = 0;
        this.apLinesObj.nilaipph = 0;
        this.apLinesObj.ppn = 0;
        this.apLinesObj.kenappn = 0;
        this.apLinesObj.pasalpph =  'N/A';
        this.apLinesObj.pph = 0; 
        this.apLinesObj.unitzise = '';
        this.apLinesObj.DimTableKey = '';
        this.apLinesObj.ibudghdkey='N/A';
        this.apLinesObj.ibudgdtkey='N/A';
        this.apLinesObj.ibudgdtkeyflag='YES';
        this.inputLineBerlanjut=0;
        
        this.calcPPh=obj.calcPPh||1;
        for (var key in obj) {
            this.apLinesObj[key] = obj[key];
        }
        this.apLinesObj.ppn= this.apLinesObj.ppn || 10;
        this.apLinesObj.pph = this.apLinesObj.pph || 0;
        this.apLinesObj.dppnlain= this.apLinesObj.dppnlain || 100;
        this.apLinesObj.amortzdate = this.apLinesObj.amortzdate ? moment(this.apLinesObj.amortzdate).format('YYYY-MM-DD') : '';

        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.apLinesObj[dim.value] = obj[dim.value];
                this.apLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.apLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        const ketemu = this.prepaidexps.find(ac => ac.kodeacc==this.apLinesObj.kodeacc);
        this.prepaidexp= (ketemu);
        // console.log ('prepaidexp : ',this.prepaidexp);
        if (this.prepaidexp){
            toastr.info('Prepaid Expense, should be Amortized');
        }

        this.tabIndex=0;
        this.inputLineBerlanjut=0;
        callback();
    },

    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;            
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            // console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;            
        // } else if ((this.model.totalinv  != parseFloat(this.model.ttlamtdue)) && (this.model.tagihandp == 0)) {
        //     toastr.error('[Total Invoice] not Balance with [Total Detail Invoice]', "ERROR MESSAGE",10000);
        //     this.isLoading=false;            
        } else if (Math.abs(this.model.totalinv - parseFloat(this.model.ttlamtdue))>0.5) {
            toastr.error('[Total Invoice] not Balance with [Total Detail Invoice]', "ERROR MESSAGE",10000);
            this.isLoading=false;            
        } else {
            try {
                this.isLoading=true;
                this.model.TableName = 'ap_invoice_tt';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PO;
                    this.model.apinvkey = this.model.apinvkey || '';
                    this.model.nomor = this.model.nomor || '';
                    this.model.taxliable= this.model.taxliable || 1;
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : undefined;
                    row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : undefined;
                    row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : undefined;
                    row.calcVAT=this.calcVAT || 1;
                    if (this.model.tagihandp==0) this.model.termin='';
                    
                    let budgetLineExist=false;
                    let itemValid=false;
                    let lineno=1;
                    let newApLines = this.apLines.items.reduce((newArr, item) => {
                        if ((item.kodeacc || '') != '') {
                            if (this.model.ibudghdkey) {
                                if (item.ibudgdtkey) {
                                    if (item.ibudghdkey=='N/A')
                                        itemValid= true;
                                    else {
                                        if (this.model.ibudghdkey==item.ibudghdkey) {
                                            itemValid= true;
                                            budgetLineExist=true;
                                        } else {
                                            itemValid= false;
                                            throw new Error(`Expenses "${item.uraian}" refer to Budget Line NOT FROM Internal Budget`);
                                        }
                                    }
                                } else itemValid= false;
                            } else itemValid= true;

                            if (itemValid==true) {
                                item.lineno = lineno;
                                item.amortzdate = item.amortzdate ? moment(item.amortzdate).format('YYYY-MM-DD') : '';
                                newArr.push(item);
                                lineno += 1;
                            }
                        }
                        return newArr;
                    }, []);
                    if ((this.model.ibudghdkey) && (budgetLineExist==false)) {
                        toastr.error('There are no reference to [Internal Budget Line]', "Error - Line/Detail AP",10000);
                        this.isLoading=false;  
                        return;          
                    }

                    row.lines = newApLines;
                    row.apDpSttl = this.apDpSttl.items;
                    // await apinv.insert(row);
                    // toastr.success("Complete successfully", "Save AP");
                    // this.close();
                    const hasil= await apinv.insert(row);
                    this.isLoading=false;
                    toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save AP",10000);
                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.isLoading=false;            
                        // const tanggal = this.model.tanggal;
                        this.model.ttlamtdue = 0;
                        this.model.ttlnetto = 0;
                        this.model.nilaippn = 0;
                        this.model.totalpph = 0;
                        this.model.totalap = 0;
                        const keys = ['tanggal','ttlamtdue','ttlnetto', 'nilaippn','grossup','totalap', 'totalpph' ];                
                        
                        for (var key in this.model) {
                            if (keys.indexOf(key) == -1) {
                                this.model[key] = '';
                            }
                        }
                        this.model.apinvkey = '';
                        this.apLines.items=[];
                        this.apDpSttl.items=[];
                        this.calcTotalDtlAp();
                        this.$v.model.$reset();
                        this.saveEnabled=true;                        
                    }
                } else {
                    this.isLoading=false;
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                    this.isLoading=false;            
                }

            } catch (error) {
                    this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.isLoading=false;            
            }

        }
    },
    calcTotalDtlAp: function () {
        try {
            this.apLines.total=this.apLines.items.length;
            this.calcVAT = this.calcVAT || 1;
            let nilaippn = 0;
            let ttlnetto = 0;
            // let ttlamtdue = 0;
            let totalpph = 0;
            // console.log('this.apLines.items : ',this.apLines.items);
            this.apLines.items.forEach( function (trx) {
                if (trx.kodeacc) {
                    ttlnetto += (trx.nilai || 0);
                    nilaippn += (trx.nilaippn || 0);
                    // ttlamtdue = ttlnetto + (nilaippn || 0);
                    totalpph += parseFloat(trx.nilaipph || 0);
                }
            });
            this.model.ttlnetto = ttlnetto;
            this.model.totalpph = totalpph;
            if (this.calcVAT == 1){
                this.model.nilaippn = nilaippn;
            }
            this.model.ttlamtdue = this.model.ttlnetto+this.model.nilaippn;
            if (this.model.grossup==1) {
                this.model.totalap = this.model.ttlamtdue;
            } else {
                this.model.totalap = this.model.ttlamtdue - this.model.totalpph;
            }
            
        } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            
        }
    },
    tanggalBerubah: function(){
            const newVal=moment(this.model.tanggal).format('YYYY');
            if ( this.tahun != newVal) {
                this.tahun=newVal ;
                apinv.getcoa({ tahun: this.tahun}).then(result => {
                        this.coa = result;
                        if  (this.coa.length==0) {
                            this.getCoa();
                        }                        
                    })
                    .catch(err => {
                        console.log('get COA -> ', err);
                    });
            } else if  (this.coa.length==0) {
                this.getCoa();
            }
    },
    getCoa: function(){
        this.tahun=(this.$store.state.user.tglaktif || '').substring(0,4)                
        apinv.getcoa({ tahun: this.tahun}).then(result => {
                this.coa = result;
            })
            .catch(err => {
                console.log('get COA -> ', err);
            });
    },    
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'payable.apinvfrmvoid')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
          router.push("home");
      }
    }
  }
};
</script>
